import { useMemo } from "react";
import useSWRInfinite from "swr/infinite";

import { swrFetcher } from "@/lib/swr";

export interface Transaction {
  transaction_hash: string;
  tx_type: 0 | 1;
  sender: string;
  from_chain: number;
  to_chain: number;
  creation_timestamp: number;
  superform_id: string;
  vault: string;
  protocol: string;
  status: SupTxStatusId;
}

export type SupTxStatusId = 0 | 1 | 2;

interface Options {
  address?: string;
  protocolId?: string;
}

const PAGE_LIMIT = 100;

export const STATUSES = {
  0: "processing",
  1: "confirmed",
  2: "reverted",
} as Record<SupTxStatusId, string>;

export const TX_TYPES = {
  0: "deposit",
  1: "withdrawal",
} as const;

export function useTransactions({ address, protocolId }: Options = {}, { enabled = true }: { enabled?: boolean } = {}) {
  const { data, isLoading, isValidating, setSize, mutate } = useSWRInfinite<Transaction[]>(
    (page: number, prevData: Transaction[] | null) => {
      if (!enabled || (prevData && !prevData.length)) return null;

      const sender = address ? address.toLowerCase() : undefined;
      const params = { offset: page * PAGE_LIMIT, limit: PAGE_LIMIT, sender, protocol: protocolId };

      return { url: `/explorer/transactions/`, params };
    },
    {
      fetcher: swrFetcher,
      revalidateFirstPage: false,
    }
  );

  const transactions = useMemo(() => (data ? data : []).reduce((acc, transactions) => acc.concat(transactions), []).filter(Boolean), [data]);

  return {
    mutate,
    transactions,
    isLoading,
    isUpdating: isValidating,
    setPage: setSize,
  };
}
